<template>
   <div>
      <h3 class="section-title">Policies &amp; Agreements</h3>

      <!-- AGENT AGREEMENT -->
      <fieldset class="border p-2 marb-12 mart-24" v-if="showType(['C','B','I','P','VC','VB','VI','VP'])">
         <legend class="w-auto">Agent Agreement</legend>
         <section-bar>Review and Acknowledge Agent Agreement</section-bar>
         <div v-if="loading" class="doc-view padt-24 padb-24 text-center">
            <i class="mart-24 fas fa-spinner fa-spin ml-orange fa-lg"></i>
         </div>
         <div v-else class="doc-view">
            <div class="inner-doc-view">
               <pdf-viewer docpath="Agent Agreement.pdf" title="Agent Agreement" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>
            </div>
         </div>

         <div class="custom-control form-control-lg custom-checkbox font-smaller" :class="{ 'error--labelinput': v$.signatures.hasSigAgent.$error }">
            <input type="checkbox" class="custom-control-input" :disabled="$parent.readOnly()"
               id="chkOne" v-model="ackAgent" @change="chg">
            <label class="custom-control-label" for="chkOne">I have read and agree to abide by the agent agreement above.</label>
         </div>
         <div class="error--msg padb-12" v-if="v$.signatures.$dirty && v$.signatures.hasSigAgent.$invalid">
            This checkbox is required
         </div>
      </fieldset>

      <!-- REPRESENTATIVE AGREEMENT -->
      <fieldset class="border p-2 marb-12 mart-24" v-if="showType(['R','B','C','P','VR','VB','VC','VP'])">
         <legend class="w-auto">Representative Agreement</legend>
         <section-bar>Review and Acknowledge Representative Agreement</section-bar>
         <div v-if="loading" class="doc-view padt-24 padb-24 text-center">
            <i class="mart-24 fas fa-spinner fa-spin ml-orange fa-lg"></i>
         </div>
         <div v-else class="doc-view">
            <div class="inner-doc-view">
               <pdf-viewer docpath="Representative Agreement.pdf" title="Representative Agreement" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>               
            </div>
         </div>

         <div class="custom-control form-control-lg custom-checkbox font-smaller" :class="{ 'error--labelinput': v$.signatures.hasSigRep.$error }">
            <input type="checkbox" class="custom-control-input" :disabled="$parent.readOnly()"
               id="chkNine" v-model="ackRep" @change="chg">
            <label class="custom-control-label" for="chkNine">I have read and agree to abide by the Representative agreement above.</label>
         </div>
         <div class="error--msg padb-12" v-if="v$.signatures.$dirty && v$.signatures.hasSigRep.$invalid">
            This checkbox is required
         </div>
      </fieldset>

      <!-- Company Policy -->
      <fieldset class="border p-2 marb-12 mart-24">
         <legend class="w-auto">Company Policy</legend>
         <section-bar>Review and Acknowledge Company Policy</section-bar>
         <div v-if="loading" class="doc-view padt-24 padb-24 text-center">
            <i class="mart-24 fas fa-spinner fa-spin ml-orange fa-lg"></i>
         </div>
         <div v-else class="doc-view">
            <div class="inner-doc-view">
               <pdf-viewer docpath="Company Policy.pdf" title="Company Policy" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>               
            </div>
         </div>

         <div class="custom-control form-control-lg custom-checkbox font-smaller" :class="{ 'error--labelinput': v$.signatures.hasSigPolicy.$error }">
            <input type="checkbox" class="custom-control-input" :disabled="$parent.readOnly()"
               id="chkTwo" v-model="ackPolicy" @change="chg">
            <label class="custom-control-label" for="chkTwo">I have read and agree to abide to the company policy above.</label>
         </div>
         <div class="error--msg padb-12" v-if="v$.signatures.$dirty && v$.signatures.hasSigPolicy.$invalid">
            This checkbox is required
         </div>
      </fieldset>

      <!-- Anti-Money Laundering -->
      <fieldset class="border p-2 marb-12">
         <legend class="w-auto">Anti-Money Laundering</legend>
         <section-bar>Review and Acknowledge Anti-Money Laundering Guide</section-bar>
         <div v-if="loading" class="doc-view padt-24 padb-24 text-center">
            <i class="mart-24 fas fa-spinner fa-spin ml-orange fa-lg"></i>
         </div>
         <div v-else class="doc-view">
            <div class="inner-doc-view">
               <pdf-viewer docpath="AML.pdf" title="AML" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>               
            </div>
         </div>
         
         <div class="custom-control form-control-lg custom-checkbox font-smaller" :class="{ 'error--labelinput': v$.signatures.hasSigAML.$error }">
            <input type="checkbox" class="custom-control-input" :disabled="$parent.readOnly()"
               id="chkThree" v-model="ackAML" @change="chg" >
            <label class="custom-control-label" for="chkThree" >I acknowledge that I have read and will comply with the guide above.</label>
         </div>
         <div class="error--msg padb-12" v-if="v$.signatures.$dirty && v$.signatures.hasSigAML.$invalid">
            This checkbox is required
         </div>
      </fieldset>

      <section-bar>Signature</section-bar>
      <div class="form-group row" v-if="!gettingSigs">
         <label for="yourName" class="col-sm-4 col-form-label" :class="{ 'error--label': v$.signatures.hasSigName.$error }">Your Name</label>
         <div class="col-sm-4">
            <input type="text" class="form-control" id="yourName" placeholder="(applicant name)" :readonly="$parent.readOnly()"
               v-model="signatures[sigName].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
                  :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigName.$invalid }">
            <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigName.$invalid">
               Your Name is Required
            </div>
         </div>
      </div>
      <div class="form-group row" v-if="!gettingSigs">
         <label for="mmName" class="col-sm-4 col-form-label" :class="{ 'error--label': v$.signatures.hasSigAgree.$error }">Mother's Maiden Name</label>
         <div class="col-sm-4">
            <input type="text" class="form-control" id="mmName" placeholder="(mother's maiden name)" :readonly="$parent.readOnly()"
               v-model="signatures[sigAgree].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
               :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigAgree.$invalid }">
            <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigAgree.$invalid">
               {{ v$.signatures.hasSigAgree.$message }}
            </div>
         </div>
      </div>

   </div>
</template>

<script>
import pdfViewer from "./pdfViewer.vue";

export default {
   name: "comp",
   components: {
      'pdf-viewer': pdfViewer
   },
   props: { 
      'apptId': Number,
      'v$': Object,
      'sigs': Array,
      'apptType': String,
   },
   data() {
      return {
         loading: true,
         gettingSigs: true,
         signatures: [],
         sigAgree: null,
         sigAckPolicy: null,
         sigAckAML: null,
         sigAckAgent: null,
         sigName: null,
         sigAckRep: null,
         ackPolicy: false,
         ackAML: false,
         ackAgent: false,
         ackRep: false,
         downloadfiletype: 4,
         keepdefaultcss: true         
      };
   },
   async mounted() {
      this.gettingSigs = true
      
      this.signatures = JSON.parse(JSON.stringify(this.sigs)) //deep copy
      this.storeSignatures()
      this.ackPolicy = (this.signatures[this.sigAckPolicy].signatureValue=='Y')
      this.ackAML = (this.signatures[this.sigAckAML].signatureValue=='Y')
      this.ackAgent = (this.signatures[this.sigAckAgent].signatureValue=='Y')
      this.ackRep = (this.signatures[this.sigAckRep].signatureValue=='Y')
      this.gettingSigs = false
      this.chg()
      this.loading = false
	},
   methods: {
      storeSignatures() {
         this.sigAgree = this.signatureByType('SIGTYP_AGREESIG')
         if (this.sigAgree==null) {
            let sigA = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_AGREESIG',
               signatureValue: this.$store.getters.signature
            }
            this.sigAgree = this.signatures.length
            this.signatures.push(sigA)
         }
         this.sigName = this.signatureByType('SIGTYP_AGREENAME')
         if (this.sigName==null) {
            let sigB = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_AGREENAME',
               signatureValue: this.$store.getters.agentName
            }
            this.sigName = this.signatures.length
            this.signatures.push(sigB)
         }
         this.sigAckPolicy = this.signatureByType('SIGTYP_POLICY_AGREE')
         if (this.sigAckPolicy==null) {
            let sigC = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_POLICY_AGREE',
               signatureValue: ''
            }
            this.sigAckPolicy = this.signatures.length
            this.signatures.push(sigC)
         }
         this.sigAckAML = this.signatureByType('SIGTYP_AML')
         if (this.sigAckAML==null) {
            let sigD = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_AML',
               signatureValue: ''
            }
            this.sigAckAML = this.signatures.length
            this.signatures.push(sigD)
         }
         this.sigAckAgent = this.signatureByType('SIGTYP_AGENT_AGREE')
         if (this.sigAckAgent==null) {
            let sigE = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_AGENT_AGREE',
               signatureValue: ''
            }
            this.sigAckAgent = this.signatures.length
            this.signatures.push(sigE)
         }
         this.sigAckRep = this.signatureByType('SIGTYP_ACKREP')
         if (this.sigAckRep==null) {
            let sigF = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_ACKREP',
               signatureValue: ''
            }
            this.sigAckRep = this.signatures.length
            this.signatures.push(sigF)
         }
      },
      signatureByType(typ) {
         if (this.signatures === undefined) return null
         let i = null
         this.signatures.forEach((element, indx) => {
            if (element.signatureTypeCode == typ) {
               i = indx
            }
         })
         return i
      },
      showType(tarr) {
         let bl =  this.$parent.showType(tarr, this.apptType)
         return bl
      },
      // report the changes to the parent
      chg() {
         if (this.gettingSigs) return
         this.v$.signatures.$touch()
         if (this.ackPolicy == true) {
            this.signatures[this.sigAckPolicy].signatureValue='Y'
         } else {
            this.signatures[this.sigAckPolicy].signatureValue='N'
         }
         if (this.ackAML == true) {
            this.signatures[this.sigAckAML].signatureValue='Y' 
         } else {
            this.signatures[this.sigAckAML].signatureValue='N' 
         }
         if (this.ackAgent == true) {
            this.signatures[this.sigAckAgent].signatureValue='Y' 
         } else {
            this.signatures[this.sigAckAgent].signatureValue='N' 
         }
         if (this.ackRep == true) {
            this.signatures[this.sigAckRep].signatureValue='Y' 
         } else {
            this.signatures[this.sigAckRep].signatureValue='N' 
         }
         this.$emit('update', { signatures: this.signatures })
      }
   }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";
@import "../../assets/css/validation.scss";

.doc-view {
   min-height: 400px;
   height: 400px;
   border: 1px solid #ddd;
}
.inner-doc-view {
   padding: 0;
   width: 100%;
}
.custom-control-label {
   display: inline-block;
   padding-top: 4px;
}
.error--labelinput {
   color: #990000;
   background-color: #FFCCCC;
   padding-left: 36px;
}
</style>